import {
    SharingLinkInfo,
    updateSharingLinkPermission,
    isRecipientsOfThisMessagePermission,
} from 'owa-link-data';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';

export function updateSharePointLinkPermissionInDraft(
    sharingLink: SharingLinkInfo,
    originalAnchorElementId: string
) {
    if (
        sharingLink &&
        isRecipientsOfThisMessagePermission(originalAnchorElementId) &&
        sharingLink.permissionLevel === AttachmentPermissionLevel.None
    ) {
        const permission: AttachmentPermissionLevel =
            sharingLink.sharingInfo.linkType === 'edit'
                ? AttachmentPermissionLevel.Edit
                : AttachmentPermissionLevel.View;
        updateSharingLinkPermission(sharingLink.linkId, permission);
    }
}
